module.exports = __webpack_public_path__ + "mainassets/img/tile1.c0229824.jpg";